module.exports = "https://and-static.ghzs.com/web/bbs-desktop/static/img/icon_popular.2ae56.png";